import api from '@/services/utils/base';
import { AxiosPromise } from 'axios';

export default class CustomMarks {
  put(payload: Bemob.CustomMark): AxiosPromise<Bemob.Response<string>> {
    return api.put('custom-marks', payload);
  }

  putBasic(path: string, payload: Bemob.CustomMarkBase): AxiosPromise<Bemob.Response<string>> {
    return api.put(`${path}/mark`, payload);
  }
}
